﻿
//import './registerServiceWorker';
// =========================

// Custom Bootstrap
//import 'css/bootstrap.min.css';
//import 'css/bootstrap-lazy.min.css';
//import '@aspnet/signalr';
//import 'jquery';
//import 'popper.js';
//import 'bootstrap';
//import '../scss/StyleSheet.scss';


let app;
import('./app')
    .then(module => {
        app = module;
    })
    .catch(err => {
        console.log(err);
    });

//let utils;
//import('./utils')
//    .then(module => {
//        utils = module;
//    })
//    .catch(err => {
//        console.log(err);
//    });


//let notificationHub;
//import('./modules/hubs/notificationHub')
//    .then(module => {
//        notificationHub = module.notificationHub;
//    })
//    .catch(err => {
//        console.log(err);
//    });

//let locations;
//import('./modules/model/locations')
//    .then(module => {
//        locations = module.locations;
//    })
//    .catch(err => {
//        console.log(err);
//    });

//let tariffs;
//import('./modules/model/tariff')
//    .then(module => {
//        tariffs = module.tariffs;
//    })
//    .catch(err => {
//        console.log(err);
//    })

//let search;
//import('./modules/model/search')
//    .then(module => {
//        search = module.search;
//    })
//    .catch(err => {
//        console.log(err);
//    })

//let registration;
//import('./modules/pages/registration')
//    .then(module => {
//        registration = module.registration;
//    })
//    .catch(err => {
//        console.log(err);
//    })

//let prices;
//import('./modules/pages/prices')
//    .then(module => {
//        prices = module.prices;
//    })
//    .catch(err => {
//        console.log(err);
//    })

//let clients;
//import('./modules/pages/clients')
//    .then(module => {
//        clients = module.clients;
//    })
//    .catch(err => {
//        console.log(err);
//    })

//let utils;
//import('./utils')
//    .then(module => {
//        utils = module;
//    })
//    .catch(err => {
//        console.log(err);
//    });
import Utils from './utils';
Utils();
import { notificationHub } from './modules/hubs/notificationHub';
import { locations } from './modules/model/locations';
import { tariffs } from './modules/model/tariff';
import { search } from './modules/model/search';
import { registration } from './modules/pages/registration';
import { prices } from './modules/pages/prices';
import { clients } from './modules/pages/clients';
import { supervisionCompany } from './modules/pages/supervisionCompany';
import { init as template } from './modules/templates/template2';
import { modal as oldModal } from "./modules/utils/modal";

window.notificationHub = notificationHub;
window.locations = locations;
window.tariffs = tariffs;
window.search = search;

window.oldModal = oldModal;
window.registration = registration;
window.prices = prices;
window.clients = clients;
window.supervisionCompany = supervisionCompany;
window.template = template;

async function init() {

}

document.addEventListener('DOMContentLoaded', function () {
    // template2
    template();
    // registration
    registration.selectCity();

    // Переворачивать стрелочки в скисках
    ppUtils.reload();

    //if (location.href.match("setting-pdf-construct") === null) {
    //    Polling.Start();
    //}
});